import { fulfilled, pending, rejected } from '../../../utils';
import { USERS } from '../../actions/actiontype';

const initialState = {
	status: '',
	loading: false,
	message: '',
	data: '',
	error: '',
};

const usersReducer = (state = initialState, action) => {
	switch (action.type) {
		case pending(USERS):
			return {
				...state,
				loading: true,
				message: '',
				error: '',
			};
		case fulfilled(USERS):
			return {
				...state,
				loading: false,
				status: action.payload.data.status,
				message: action.payload.data.message,
				data: action.payload.data.data,
				error: '',
			};
		case rejected(USERS):
			return {
				...state,
				loading: false,
				message: '',
				error: status ===500 ? "Something went wrong. Please try again later" : action?.payload?.response.data.message,
			};
		default:
			return state;
	}
};

export default usersReducer;
